import api from '@/api/index.js'

const bot_clients = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_BOT_CLIENTS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_BOT_CLIENTS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_BOT_CLIENTS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    GetBotClients({commit}) {
      commit('SET_BOT_CLIENTS_LOADING', true)
      return api.get('bot-clients?limit=0&offset=0')
        .then((response) => {
          commit('SET_BOT_CLIENTS', response)
          commit('SET_BOT_CLIENTS_LOADING', false)
        })
        .catch((error) => {
          commit('SET_BOT_CLIENTS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default bot_clients
